import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Upload-file",
  "use": "icon-Upload-file-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 16\" id=\"icon-Upload-file\"><path d=\"M7.833 12.667h1.333V9.883l1.067 1.067.933-.95L8.5 7.333 5.833 10l.95.934 1.05-1.05v2.783Zm4.667 2h-8c-.367 0-.68-.13-.942-.392a1.284 1.284 0 0 1-.391-.941V2.667c0-.367.13-.68.392-.942.26-.261.574-.392.94-.392h5.334l4 4v8c0 .367-.13.681-.391.942-.261.261-.575.392-.942.392ZM9.166 6V2.667H4.5v10.666h8V6H9.166ZM4.5 2.667V6 2.667v10.667V2.667Z\" fill=\"#4066D4\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol